import { useContext } from 'react';
import { AuthContext } from '../context/AuthContext.jsx';
import type { AuthContextType } from '../types/index.ts';

export const useAuth = (): AuthContextType => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
